import { Gradient } from '@/components/gradient'
import { RestaurantDealPreview } from '@/features/restaurants/restaurant-deal-preview'
import { cn } from '@/utils/styles/cn'
import { RestaurantFlashDealPreview } from '../restaurant-flash-deal-preview'
import { RestaurantRewardPreview } from '../restaurant-reward-preview'

interface IRestaurantCardDealsProps {
    restaurant: {
        deals?: Array<{ name: string | null; eventDeal?: boolean | null }> | null
        uuid: string
        loyalty?: { rewards?: Array<{ name: string }> } | null
    }
    className?: string
}

export const RestaurantCardDeals = ({ restaurant, className }: IRestaurantCardDealsProps) => {
    if (!restaurant.deals?.length) return null

    return (
        <div className="relative overflow-hidden">
            <div
                className={cn(
                    `flex flex-1 mt-2 items-center justify-start overflow-x-auto gap-2 whitespace-nowrap relative w-full
                    min-h-4 min-w-full flex-grow-0 flex-shrink-0 scrollbar-hide`,
                    className
                )}
            >
                {restaurant.deals?.map((deal, index) => {
                    if (deal.eventDeal)
                        return (
                            <RestaurantFlashDealPreview
                                key={'restaurant-card' + restaurant.uuid + deal.name + index}
                            >
                                {deal.name}
                            </RestaurantFlashDealPreview>
                        )
                    return (
                        <RestaurantDealPreview
                            key={'restaurant-card' + restaurant.uuid + deal.name + index}
                        >
                            {deal.name}
                        </RestaurantDealPreview>
                    )
                })}

                {restaurant.loyalty?.rewards?.map((reward, index) => {
                    return (
                        <RestaurantRewardPreview
                            key={'restaurant-card' + restaurant.uuid + reward.name + index}
                        >
                            {reward.name}
                        </RestaurantRewardPreview>
                    )
                })}

                <div className="w-20" />
            </div>

            <Gradient className="absolute right-0 top-0 min-w-[20px]" />
        </div>
    )
}
